<template>
  <div  class="map" style="height: 250px; width: 250px" >
    <div v-on:click="openMapUrl()" class="mapzz"></div>
    <div style="width:100%;height:100%" :id="uniqueKey"></div>
  </div>
</template>
  
<script>
  
  export default {
    name: 'MapItem',
    props: ['latitude', 'longitude', 'address', 'uniqueKey'],
    methods: {
      openMapUrl(){
        const { latitude, longitude, address } = this;
        console.log('三生三世',latitude, longitude, address);
        if(latitude && longitude){ // 打开地图
        //https://map.baidu.com/mobile/webapp/place/detail/qt=s&wd=%E4%B8%89%E6%B6%A6%E5%9F%8E&c=1&searchFlag=bigBox&version=5&exptype=dep&src_from=webapp_all_bigbox&src=2&uid=8ec287326e5f1e2f210220cf/i=0&showall=1&pos=0&da_ref=listclk&da_qrtp=11&da_adquery=%E4%B8%89%E6%B6%A6%E5%9F%8E&da_adtitle=%E4%B8%89%E6%B6%A6%E5%9F%8E&da_adindus=%E6%88%BF%E5%9C%B0%E4%BA%A7%3B%E4%BD%8F%E5%AE%85%E5%8C%BA&detail_from=list&vt=map
          const url = `https://map.baidu.com/search/${address}/?querytype=s&da_src=shareurl&wd=${address}&c=158&src=0&pn=0&sug=1&l=13&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2&vt=map`;
          // const encodeUrl = encodeURIComponent(url);
          window.open(url);
          // this.$router.push(`/web/${encodeUrl}`);
        }
      }
    },

    mounted(){
      const _this = this;
      const { latitude, longitude, uniqueKey } = this;
      const renderMap = () => {
        const map = new BMap.Map(uniqueKey);
        map.centerAndZoom(new BMap.Point(longitude, latitude), 15);
        map.addOverlay(new BMap.Marker({lng:longitude,lat:latitude}));
      };
      setTimeout(() => {
        renderMap();
      }, 200);
    }

  }
</script>

<style lang="less">
  .map{
    position: relative;
    .mapzz{
      position: absolute;
      left:0;
      top:0;
      width:100%;
      height: 100%;
      z-index: 22;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/MapItem.vue